import {gql} from 'apollo-angular';

export const StatusFragment = gql`
  fragment statusFields on Status {
    type,
    message
  }
`;
